import React from "react";
import { useProgressiveImg } from "designSystem/hooks";
import CsiImage, { CsiImageProps } from "./CsiImage";

interface progressiveCsiImageProps {
	/** props directly for CsiImage */
	CsiImageProps?: Omit<CsiImageProps, "src">;

	/** a large image to load after the small image */
	largeImgSrc: string;

	/** a small image load while the large image loads */
	smallImgSrc: string;
}

const ProgressiveCsiImage = (props: progressiveCsiImageProps) => {
	const {
		CsiImageProps,
		largeImgSrc,
		smallImgSrc,
	} = props;
	const { src } = useProgressiveImg(smallImgSrc, largeImgSrc);

	return (
		<CsiImage
			{...CsiImageProps}
			src={src}
		/>
	);
};

export default ProgressiveCsiImage;